/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { FormFieldStyle } from "@insite/mobius/FormField";
import getColor from "@insite/mobius/utilities/getColor";
import React from "react";
import { css } from "styled-components";

const SortByAndPaginationContainerWidget = ({ id }: WidgetProps) => {
    return (
        <StyledWrapper
            css={css`
                border: 1px solid ${getColor("common.border")};
                padding: 13px 17px;
                margin-bottom: 30px;               
            `}
        >
            <Zone contentId={id} zoneName="Content" />
        </StyledWrapper>
    );
};

export const definition: WidgetDefinition = {
    group: "My Lists",
    displayName: "Sort And Pagination Container",
    allowedContexts: ["MyListsPage"],
};

const widgetModule: WidgetModule = {
    component: SortByAndPaginationContainerWidget,
    definition,
};

export default widgetModule;
